export default __webpack_public_path__ + "static/media/implement_disable.0b5da9e1.svg";